












import { Component, Prop, Vue } from 'vue-property-decorator';
import * as utils from '../utils';

const APP_ID = process.env.VUE_APP_FB_APP_ID

if (!APP_ID) {
  const e = 'VUE_APP_FB_APP_ID is null from environment (check you .env and .env.local)'
  console.error(e)
  throw(e)
}

interface fbComment { story_fbid: number, id: number, comment_id: number }

@Component({
  name: 'FBComments',
  components: { 
   }
})
export default class FBComments extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: false })
  public useDynamicComments: boolean

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading; }

  // if useDynamicComments === false, we show these fixed comments instead
  public fbComments: fbComment[] = [
    { story_fbid: 118298769712915, id: 101289111413881, comment_id: 118947846314674 },        // And I am so grateful to have it. (in reply to Have been writing mine over past several years so was ready when my daughter asked me to do that.)
    { story_fbid: 113999396809519, id: 101289111413881, comment_id: 116956676513791 },        // My sisters and I often reminisce about the stories my dad used to tell about his much younger days. It would be nice to hear them in his voice again.
    { story_fbid: 111600647049394, id: 101289111413881, comment_id: 112334790309313 },        // Former Immigrants. Your Grandchildren will want to know your story. Write it down now.
 // { story_fbid: 111600550382737, id: 101289111413881, comment_id: 116736123202513 },        // EVERY ONE ...
    { story_fbid: 108106197398839, id: 101289111413881, comment_id: 110396537169805 },        // These stories are priceless.
    { story_fbid: 119957496213709, id: 101289111413881, comment_id: 123285272547598 },        // How many times have I wished to hear my father tell the stories of his life...in his voice. If I could hear my mother talk about her stories of growing up in Louisiana. If you still have your parents, do this.. They take the stories in their own voices with them when they go.
    { story_fbid: 113999026809556, id: 101289111413881, comment_id: 122101025999356 },        // I have captured some of my father's stories as I remember living through the Great Depression of the 1930s on the FARM before we had electricity, running water, or mechanized farm machinery. We understood HONEST WORK done with HANDS.
    { story_fbid: 113999026809556, id: 101289111413881, comment_id: 122058456003613 },        // Your children and grandchildren will (almost certainly) thank you.
    { story_fbid: 119963599546432, id: 101289111413881, comment_id: 123327072543418 },        // Oral family histories are the best. 🥰🗣 👥👥👥
    { story_fbid: 119957496213709, id: 101289111413881, comment_id: 123412492534876 },        // How I would love to have a conversation with my precious Mama one more time...She told us so much about her life....I would love to hear her tell me something just 1 more time...The sad thing is she never will...:'( "
    { story_fbid: 119957496213709, id: 101289111413881, comment_id: 125066335702825 },        // Many years ago I recorded my Grandmother telling stories about her history, and singing a song from her youth. That record of her history was destroyed because-well, why doesn't matter now. I have memories of her, of the times I spent with her and the large family we had, will always be some of the greatest memories of my youth. Those times will never leave me. I just wish there was a way to share them with my children and generations beyond.
  ]

  // public functions available to the html template
  public fbCommentPermalink(fbc: fbComment): string {
    return `https://www.facebook.com/permalink.php?story_fbid=${fbc.story_fbid}&id=${fbc.id}&comment_id=${fbc.comment_id}`
  }

  public getFacebookCommentsPageURL(): string {
    return utils.getWebURLprefix() + '/'
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`);   // do for all to analyze anonymous page loads

    // @ts-ignore:
    await Vue.loadScript(`https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v6.0&appId=${APP_ID}&autoLogAppEvents=1`);
  }

  private async mounted() { 
    // if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);   // do for all to analyze anonymous page loads

  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }


}
